import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-runbankstatementanalysis',
  templateUrl: './runbankstatementanalysis.component.html',
  styleUrls: ['./runbankstatementanalysis.component.css']
})
export class RunbankstatementanalysisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
